export const vatPlaceholders = [
  { countryKey: 'DE', placeholder: 'DE123456789' },
  { countryKey: 'AT', placeholder: 'ATU12345678' },
  { countryKey: 'BE', placeholder: 'BE0123456789' },
  { countryKey: 'BG', placeholder: 'BG0123456789' },
  { countryKey: 'CY', placeholder: 'CY12345678Z' },
  { countryKey: 'HR', placeholder: 'HR12345678912' },
  { countryKey: 'DK', placeholder: 'DK12345678' },
  { countryKey: 'ES', placeholder: 'ESA1234567Z' },
  { countryKey: 'EE', placeholder: 'EE123456789' },
  { countryKey: 'FR', placeholder: 'FRAB123456789' },
  { countryKey: 'EL', placeholder: 'EL123456789' },
  { countryKey: 'HU', placeholder: 'HU12345678912' },
  { countryKey: 'IE', placeholder: 'IE1234567AB' },
  { countryKey: 'FI', placeholder: 'FI12345678' },
  { countryKey: 'IT', placeholder: 'IT12345678912' },
  { countryKey: 'LV', placeholder: 'LV12345678912' },
  { countryKey: 'LT', placeholder: 'LT123456789123' },
  { countryKey: 'LU', placeholder: 'LU12345678' },
  { countryKey: 'MT', placeholder: 'MT12345678' },
  { countryKey: 'PL', placeholder: 'PL1234567890' },
  { countryKey: 'NL', placeholder: 'NL123456789B12' },
  { countryKey: 'PT', placeholder: 'PT123456789' },
  { countryKey: 'RO', placeholder: 'RO1234567891' },
  { countryKey: 'CZ', placeholder: 'CZ1234567890' },
  { countryKey: 'SI', placeholder: 'SI12345678' },
  { countryKey: 'SK', placeholder: 'SK1234567891' },
  { countryKey: 'SE', placeholder: 'SE123456789123' },
  { countryKey: 'GB', placeholder: 'XI123456789' },
];
